import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicePage from './pages/ServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import NewsDetailPage from './pages/NewsDetailPage';
import CaseStudyListPage from './pages/CaseStudyListPage';
import CaseStudyDetailPage from './pages/CaseStudyDetailPage';
import AITrainingPage from './pages/service/ai-training';
import CompanyPage from './pages/CompanyPage';
import ContactPage from './pages/ContactPage';
import DetailedNews1Page from './pages/news/detailed-news1';
import DetailedNews2Page from './pages/news/detailed-news2';
import DetailedNews3Page from './pages/news/detailed-news3';
import DetailedNews4Page from './pages/news/detailed-news4';
import DetailedNews5Page from './pages/news/detailed-news5';
import RecruitListPage from './pages/RecruitListPage';
import RecruitDetailPage from './pages/RecruitDetailPage';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="bg-white text-black" style={{ fontFamily: "'Inter', sans-serif" }}>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/service" element={<ServicePage />} />
            <Route path="/case-study" element={<CaseStudyListPage />} />
            <Route path="/case-study/:id" element={<CaseStudyDetailPage />} />
            <Route path="/news" element={<NewsDetailPage />} />
            <Route path="/news/1" element={<DetailedNews1Page />} />
            <Route path="/news/2" element={<DetailedNews2Page />} />
            <Route path="/news/3" element={<DetailedNews3Page />} />
            <Route path="/news/4" element={<DetailedNews4Page />} />
            <Route path="/news/5" element={<DetailedNews5Page />} />
            <Route path="/company" element={<CompanyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/recruit" element={<RecruitListPage />} />
            <Route path="/recruit/:id" element={<RecruitDetailPage />} />
            <Route path="/service/ai-training" element={<AITrainingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;